module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n<div class=\"row\">\r\n    <div class=\"col-sm-6\">\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/group-booking/supplier-data-details/supplier-data-details.view.component.html
// module id = ../../../../../src/app/modules/group-booking/supplier-data-details/supplier-data-details.view.component.html
// module chunks = main